const toMilliseconds=value=> {
    if(value==null||value==='')return NaN;
    const numeric=Number(value);
    if(Number.isFinite(numeric))return numeric<1000000000000?numeric*1000:numeric;
    return Date.parse(value);
  };
  
  export const getExtractionRuntime=job=> {
    if(job?.status!=='done')return null;
    const started=toMilliseconds(job.started_at);
    const completed=toMilliseconds(job.completed_at);
    if(!Number.isFinite(started)||!Number.isFinite(completed))return null;
    const minutes=Math.max(0,Math.round((completed-started)/60000));
    return {
      minutes,
      tone:minutes<=20?'fast':minutes<=40?'moderate':'slow',
      label:minutes<60?`${minutes} min total`:`${Math.floor(minutes/60)} hr ${minutes%60} min total`
    };
  };
  